import MyBookingTemplate from "../../../templates/users/mybooking";

const MyBookingScreen = () => {
  return <MyBookingTemplate />;
};

export default MyBookingScreen;
